import { Household, Token, User } from '../../../common/src/model.ts';
import { localStorageGet, LocalStorageKey } from './client_local_storage.ts';
import { useHousehold } from './use_household.tsx';
import { useLocalStorage } from './use_local_storage.tsx';

export function useUser(): { user?: User } {
  const { household } = useHousehold();
  const [activeUserToken] = useLocalStorage(LocalStorageKey.ActiveUserToken);
  const user = findUserInHousehold(household, activeUserToken);
  return { ...(user && { user }) };
}

export function getUser(): User | undefined {
  const household = localStorageGet(LocalStorageKey.Household);
  const activeUserToken = localStorageGet(LocalStorageKey.ActiveUserToken);
  return findUserInHousehold(household, activeUserToken);
}

function findUserInHousehold(household: Household | undefined, userToken: Token | undefined): User | undefined {
  if (userToken === undefined) {
    return;
  }
  return household?.users?.find(({ token }) => token === userToken);
}
